import { combineReducers } from 'redux';
import stateReducer from './State/stateReducer';
import appSettingsReducer from './AppSettings/appSettingsReducer';
import ordersReducer from "./Orders/ordersReducer";
import authReducer from "./Auth/authReducer";
import actionMenuReducer from "./ActionMenu/actionMenuReducer";
import subActionMenuReducer from "./SubActionMenu/subActionMenuReducer";
import sendableStatesReducer from "./SendableStates/sendableStatesReducer";
import {reducer as toastr} from 'react-redux-toastr'

const rootReducer = combineReducers({
   stateReducer,
   appSettingsReducer,
   ordersReducer,
   authReducer,
   actionMenuReducer,
   subActionMenuReducer,
   sendableStatesReducer,
   toastr
  });
  
  export default rootReducer;